import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { MenuWrapper, MenuContainer } from './Container.styles';
import Header from './components/Header';

type ContainerProps = {
  children: ReactNode;
  isOpen: boolean;
  hasActiveSubmenu: boolean;
  handleHeaderOnClick: (props) => void;
};
const Container = ({
  children,
  isOpen,
  hasActiveSubmenu,
  handleHeaderOnClick,
}: ContainerProps) => (
  <MenuContainer
    id="mobile-navigation"
    aria-hidden={isOpen ? 'false' : 'true'}
    className={classNames({
      visible: isOpen,
      'submenu-visible': hasActiveSubmenu,
    })}
  >
    <Header showBack={hasActiveSubmenu} handleOnClick={handleHeaderOnClick} />

    <MenuWrapper>{children}</MenuWrapper>
  </MenuContainer>
);

export default Container;
